import { render, staticRenderFns } from "./properties-block-faq-item.vue?vue&type=template&id=2d9b54be&scoped=true"
import script from "./properties-block-faq-item.vue?vue&type=script&lang=js"
export * from "./properties-block-faq-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9b54be",
  null
  
)

export default component.exports